/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { mapCollectionsForCarousel } from 'bundles/collections-carousel/utils/mappingUtils';
import { getGenAICollectionSets } from 'bundles/front-page/constants/genAICollectionSets';
import useDiscoveryCollectionsData from 'bundles/front-page/hooks/useDiscoveryCollectionsData';
import { useMobileOnlyStreamlinedLOHP } from 'bundles/front-page/utils/useStreamlinedLOHP';
import CollectionsModule from 'bundles/unified-common/modules/CollectionsModule';

import BackgroundImage from 'images/front-page/GenAI-Spotlight-Collection.png';

import _t from 'i18n!nls/front-page';

const styles = {
  container: css`
    margin: var(--cds-spacing-400) 0;
    border-radius: var(--cds-border-radius-200);
    overflow: hidden;
  `,
};

const GenAICollections = () => {
  const isStreamlinedMWebLOHPVariantC = useMobileOnlyStreamlinedLOHP() === 'C';
  const [currentCollectionSetIndex, setCurrentCollectionSetIndex] = React.useState(0);
  const handleFilterChange = (index: number) => {
    setCurrentCollectionSetIndex(index);
  };

  const genAICollectionSets = getGenAICollectionSets();
  const filters = genAICollectionSets.map((collectionSet, index) => {
    return {
      id: index.toString(),
      filterName: collectionSet.filterName,
    };
  });

  const { collections, loadingCollections: isCollectionsLoading } = useDiscoveryCollectionsData({
    contextId: genAICollectionSets[currentCollectionSetIndex].contextId as string,
    contextType: genAICollectionSets[currentCollectionSetIndex].context as string,
  });

  // remove collection title
  const formattedCollections = mapCollectionsForCarousel(collections).map((collection) => {
    return {
      ...collection,
      title: '',
    };
  });

  return (
    <div css={styles.container}>
      <CollectionsModule
        filters={filters}
        onFilterChange={handleFilterChange}
        currentCollectionSetIndex={currentCollectionSetIndex}
        collections={formattedCollections}
        numOfEntriesPerCollection={3}
        isCollectionsLoading={isCollectionsLoading}
        showAllEntries
        cta={{
          text: _t('View all GenAI'),
          target: '/explore/generative-ai',
          variant: isStreamlinedMWebLOHPVariantC ? 'secondary' : 'primary',
        }}
        lazyLoadImage
        description={_t('Identify, develop and execute impactful GenAI business strategies.')}
        headline={_t('Get started with GenAI')}
        layout="text3/image9"
        backgroundColor="light-blue"
        showRoundedCorners
        backgroundImage={{
          width: 726,
          height: 480,
          url: BackgroundImage,
          description: '',
        }}
      />
    </div>
  );
};

export default GenAICollections;
